/**
 * 法律顾问静态资源 — 与主站 legalCounsel.ts coverSrc 一致（绝对 URL，供 Web Component / 外链站复用）
 */
export const GCSA_LEGAL_COUNSEL_COVER = {
  leelee: 'https://gcsa.org/images/legal/lee-lee-logo.png',
  fn: 'https://gcsa.org/images/legal/fn-logo.png?v=2',
  pmt: 'https://gcsa.org/images/legal/pmt-logo.png',
  yuanshu: 'https://gcsa.org/images/legal/yuanshu-logo.jpg'
} as const;

export type GcsaLegalCounselCoverId = keyof typeof GCSA_LEGAL_COUNSEL_COVER;

export function resolveLegalCounselCover(firmId: GcsaLegalCounselCoverId): string {
  return GCSA_LEGAL_COUNSEL_COVER[firmId];
}
